var map = {
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"default~modules-dashboard-dashboard-module~modules-req-dashboard-req-dashboard-module",
		"modules-dashboard-dashboard-module"
	],
	"./modules/detailed-wipreport/detailed-wipreport.module": [
		"./src/app/modules/detailed-wipreport/detailed-wipreport.module.ts",
		"modules-detailed-wipreport-detailed-wipreport-module"
	],
	"./modules/hr/hr.module": [
		"./src/app/modules/hr/hr.module.ts",
		"default~modules-hr-hr-module~modules-ims-ims-module",
		"modules-hr-hr-module"
	],
	"./modules/import/import.module": [
		"./src/app/modules/import/import.module.ts",
		"modules-import-import-module"
	],
	"./modules/ims/ims.module": [
		"./src/app/modules/ims/ims.module.ts",
		"default~modules-ims-ims-module~modules-requisition-requisition-module~modules-stock-stock-module",
		"default~modules-hr-hr-module~modules-ims-ims-module",
		"modules-ims-ims-module"
	],
	"./modules/invoicing/invoicing.module": [
		"./src/app/modules/invoicing/invoicing.module.ts",
		"modules-invoicing-invoicing-module"
	],
	"./modules/jse/jse.module": [
		"./src/app/modules/jse/jse.module.ts",
		"modules-jse-jse-module"
	],
	"./modules/party/party.module": [
		"./src/app/modules/party/party.module.ts",
		"modules-party-party-module"
	],
	"./modules/req-dashboard/req-dashboard.module": [
		"./src/app/modules/req-dashboard/req-dashboard.module.ts",
		"default~modules-dashboard-dashboard-module~modules-req-dashboard-req-dashboard-module",
		"modules-req-dashboard-req-dashboard-module"
	],
	"./modules/req-reports/req-reports.module": [
		"./src/app/modules/req-reports/req-reports.module.ts",
		"modules-req-reports-req-reports-module"
	],
	"./modules/requisition/requisition.module": [
		"./src/app/modules/requisition/requisition.module.ts",
		"default~modules-ims-ims-module~modules-requisition-requisition-module~modules-stock-stock-module",
		"modules-requisition-requisition-module"
	],
	"./modules/stock/stock.module": [
		"./src/app/modules/stock/stock.module.ts",
		"default~modules-ims-ims-module~modules-requisition-requisition-module~modules-stock-stock-module",
		"modules-stock-stock-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;